export const FinancialRisksNoticeTexts = {
  notice: 'Оценивайте свои финансовые возможности и риски',
};
